export default {
  headerStyles: {
    fontFamily: "Roboto",
    color: "#3f51b5",
    padding: "0.5rem",
  },
};
